import { gql } from '@apollo/client';

export const CREATE_USER = gql`
  mutation CreateUser(
    $name: String!
    $role: String!
    $email: String!
    $brandId: String
    $hasAccess: Boolean
    $subrole: String
  ) {
    createUser(
      name: $name
      role: $role
      email: $email
      brandId: $brandId
      hasAccess: $hasAccess
      subrole: $subrole
    ) {
      status
      code
      data
      error
    }
  }
`;

export const CREATE_INFLUENCER = gql`
  mutation CreateInfluencer(
    $name: String!
    $role: String!
    $email: String!
    $brandId: String
    $hasAccess: Boolean
    $subrole: String
  ) {
    createUser(
      name: $name
      role: $role
      email: $email
      brandId: $brandId
      hasAccess: $hasAccess
      subrole: $subrole
    ) {
      status
      code
      data
      error
    }
  }
`;

export const UPDATE_PROFILE = gql`
  mutation UpdateUser(
    $userId: String!
    $email: String
    $email_enabled: Boolean
    $name: String
    $phone: String
    $time_zone: String
    $time_zone_automatic: Boolean
    $hasAccess: Boolean
    $language: String
    $language_automatic: Boolean
    $subrole: String
    $holdedIdSpain: String
    $holdedIdAndorra: String
    $ppt_name: String
  ) {
    updateUser(
      userId: $userId
      email: $email
      name: $name
      phone: $phone
      email_enabled: $email_enabled
      time_zone: $time_zone
      time_zone_automatic: $time_zone_automatic
      hasAccess: $hasAccess
      language: $language
      language_automatic: $language_automatic
      subrole: $subrole
      holdedIdSpain: $holdedIdSpain
      holdedIdAndorra: $holdedIdAndorra
      ppt_name: $ppt_name
    ) {
      status
      code
      data
      error
    }
  }
`;

export const USER_SET_SOCIAL_NETWORK = gql`
  mutation SetSocialNetwork($userId: String!, $networks: [newNetwork]!) {
    setSocialNetwork(userId: $userId, networks: $networks) {
      status
      code
      data
      error
    }
  }
`;

export const UPDATE_PROFILE_PICTURE = gql`
  mutation UpdateUserProfilePicture($userId: String!, $file: Upload!) {
    updateUserProfilePicture(userId: $userId, file: $file) {
      status
      code
      data
      error
    }
  }
`;

export const UPDATE_PROFILE_NOTIFICATION = gql`
  mutation UpdateProfileNotification(
    $type: String!
    $key: String!
    $value: Boolean!
  ) {
    updateProfileNotification(type: $type, key: $key, value: $value) {
      status
      code
      data
      error
    }
  }
`;

export const DELETE_USER = gql`
  mutation DeleteUser($userId: String!) {
    deleteUser(userId: $userId) {
      status
      code
      data
      error
    }
  }
`;

export const RESEND_USER_INVITE = gql`
  mutation ResendInvite($user_id: String!) {
    resendInvite(user_id: $user_id) {
      status
      code
      data
      error
    }
  }
`;

export const UPDATE_INFLUENCER_EXCLUSIVITY = gql`
  mutation UpdateInfluencerExclusivity(
    $userId: String!
    $exclusivity: Boolean!
  ) {
    updateInfluencerExclusivity(userId: $userId, exclusivity: $exclusivity) {
      status
      code
      data
      error
    }
  }
`;
